import BaseApi from "@/api/baseApi";
export default {
  addOrUddate(form) {
    return BaseApi.post('api-ear-marks/api/v1/earmark-default-prices', form);
  },
  fetchNewest(articleGroup) {
    return BaseApi.get(`api-ear-marks/api/v1/earmark-default-prices/newest/${articleGroup}`);
  }
}
